export default [
  {
    path: '/main/frota/infractions-types',
    meta: {
      tag: 'list_infractions_types',
      name: 'Tipos de Infrações',
      breadcrumb: 'Tipos de Infrações'
    },
    component: () => import(/* webpackChunkName: "infractions-types-list" */ '@/views/main/settings/frota/infractions-types/Index.vue'),
    children: [
      {
        path: '',
        name: 'listinfractionstypes',
        meta: {
          tag: 'list_infractions_types',
          menu: 'settings',
          name: 'Tipos de Infrações'
        },
        component: () => import(/* webpackChunkName: "infractions-types-list" */ '@/views/main/settings/frota/infractions-types/List.vue')
      },
      {
        path: '/main/frota/infraction-type/add',
        name: 'addinfractiontype',
        meta: {
          tag: 'add_infraction_type',
          menu: 'settings',
          name: 'Adicionar | Tipo de Infração',
          breadcrumb: 'Adicionar Tipo de Infração'
        },
        component: () => import(/* webpackChunkName: "infractions-types-add" */ '@/views/main/settings/frota/infractions-types/Add.vue')
      },
      {
        path: '/main/frota/infraction-type/:id',
        name: 'editinfractiontype',
        meta: {
          tag: 'edit_infraction_type',
          menu: 'settings',
          name: 'Editar | Tipo de Infração',
          breadcrumb: 'Editar Tipo de Infração'
        },
        component: () => import(/* webpackChunkName: "infractions-types-edit" */ '@/views/main/settings/frota/infractions-types/Edit.vue')
      }
    ]
  },
]
